const ingredientsInitial = [
    {
      id: 'pizza-dough',
      name: 'Pizza dough',
      items: [
        {
          name: 'All-purpose flour',
          number: '2.25',
          unit: 'cups',
          numberMetric: '270',
          unitMetric: 'g'
        },
        {
          name: 'Kosher salt',
          number: '1.5',
          unit: 'tsp'
        },
        {
          name: `<a href="https://www.fleischmannsyeast.com/product-page/" target="_blank">Fleischmann's RapidRise Yeast</a>`,
          number: '1',
          unit: 'tsp'
        },
        {
          name: 'Warm water',
          number: '0.75',
          unit: 'cup',
          numberMetric: '175',
          unitMetric: 'g'
        },
        {
          name: 'Olive oil',
          note: 'for pan, dough, and stretching'
        }
      ]
    },
    {
      id: 'pizza-toppings',
      name: 'Toppings',
      items: [
        {
          name: `<a href="https://www.raos.com/products/pizza-sauce" target="_blank">Rao's Pizza Sauce</a>`,
          number: '0.5',
          unit: 'cup',
          numberMetric: '122',
          unitMetric: 'g'
        },
        {
          name: 'Shredded mozzarella',
          number: '8',
          unit: 'oz',
          numberMetric: '227',
          unitMetric: 'g'
        },
        {
          name: 'Aged provolone (cubed)',
          number: '3',
          unit: 'oz',
          numberMetric: '85',
          unitMetric: 'g',
          note: 'optional',
        },
        {
          name: 'Pepperoni cups',
          number: '5',
          unit: 'oz',
          numberMetric: '142',
          unitMetric: 'g'
        }
      ],
      note: 'Feel free to add any extra toppings (sliced mushrooms, peppers, onion, sausage, etc.)'
    }
  ];

export const ingredients = ingredientsInitial.map((ingredient) => ({
    ...ingredient,
    items: ingredient.items.map((item) => ({
        ...item,
        checked: false,
    })),
}));